import invitation_border1 from "../images/wedding/invitation_border1.png";
import om from "../images/wedding/om.png";
import venkateswara_swami from "../images/wedding/venkateswara_swami.png";
import '../invitations/Invitation.css'
const invitationElements = [
{
id:1,
type:"image",
src:invitation_border1,
x:0,
y:0,
width:200,
height:100
},
{
id:17,
type:"image",
src:om,
x:285,
y:20,
width:70,
height:70
},
{
id:2,
type:"image",
src:invitation_border1,
x:410,
y:0,
width:200,
height:100
},
{
id:3,
type:"text",
text:"✨ Wedding Invitation ✨",
x:35,
y:100,
fontSize:40,
fontFamily:"Libre Baskerville",
fill:"#000"
},
{
id:4,
type:"text",
text:"Together with their families,",
x:150,
y:150,
fontSize:30,
fontFamily:"Dancing Script",
fill:"#801818"
},
{
id:5,
type:"text",
text:"Rahul ❤️ Priya",
x:200,
y:200,
fontSize:30,
fontFamily:"Raleway",
fill:"#8B0000"
},
{
id:6,
type:"text",
text:"joyfully invite you to celebrate their wedding.",
x:150,
y:530,
fontSize:20,
fontFamily:"Dancing Script",
fill:"#8B0000"
},
{
id:7,
type:"text",
text:"💍 Wedding Ceremony 📅 Sunday, 15/03/2026 ⏰ 06:00 pm",
x:100,
y:560,
fontSize:15,
fontFamily:"Cardo",
fill:"#8B0000"
},
{
id:8,
type:"text",
text:"📍 Venue:",
x:250,
y:600,
fontSize:22,
fontFamily:"Josefin Sans",
fill:"#8B0000"
},
{
id:9,
type:"text",
text:"ABC FUNCTION HALL",
x:220,
y:620,
fontSize:20,
fontFamily:"Josefin Sans",
fill:"#8B0000"
},
{
id:10,
type:"text",
text:"City / Address",
x:220,
y:640,
fontSize:20,
fontFamily:"Josefin Sans",
fill:"#8B0000"
},
{
id:11,
type:"text",
text:"Your presence and blessings",
x:220,
y:690,
fontSize:18,
fontFamily:"Dancing Script",
fill:"#8B0000"
},
{
id:12,
type:"text",
text:"will make our day even more special.",
x:180,
y:710,
fontSize:18,
fontFamily:"Dancing Script",
fill:"#8B0000"
},
{
id:13,
type:"text",
text:"With love,",
x:250,
y:740,
fontSize:18,
fontFamily:"Great Vibes",
fill:"#8B0000"
},
{
id:14,
type:"text",
text:"Rahul & Priya",
x:230,
y:760,
fontSize:18,
fontFamily:"Great Vibes",
fill:"#8B0000"
},
{
id:15,
type:"text",
text:"📞648200xxxx",
x:230,
y:780,
fontSize:18,
fontFamily:"Great Vibes",
fill:"#8B0000"
},
{
id:16,
type:"image",
src:venkateswara_swami,
x:150,
y:250,
width:290,
height:270
}
];

export default invitationElements;